@let controlValue = control();
@if (
  ((rootFormGroup()?.submitted() ?? false) === true && controlValue.invalid) ||
  (controlValue.invalid && (controlValue.touched || controlValue.dirty))
) {
  @let error = (controlValue.errors | keyvalue)?.[0]!;
  @let errorValue = error?.value;
  <!-- prettier-ignore -->
  <span @fadeOut2XFastLeave>{{
      error.key
        | pctFormResolveErrorKey: i18nScope + '.VALIDATION' : overrideErrors()
        | transloco: ((errorValue | isSerializable) ? errorValue : null)
    }}</span>
}
